import { COLORS } from "utils/constants/colors"
import "chartjs-plugin-datalabels"
import _ from "lodash"
import { truncateLabel } from "services/charts/labelTruncation"

export const dataLabelsPlugin = (
  unit = undefined,
  label = undefined,
  valueAndUnitOn2lines = false
) => {
  return {
    datalabels: {
      display: function (context) {
        const summedData = context.chart.data.datasets.map(
          (dataset, datasetIndex) => {
            return _.sumBy(context.chart.data.datasets, (dataset) =>
              dataset.type === "line" ? 0 : dataset.data[datasetIndex]
            )
          }
        )
        const valueMax = Math.max(..._.without(summedData, null))

        const currentValue = context.dataset.data[context.dataIndex]
        return currentValue / valueMax > 0.05
      },

      formatter: function (value) {
        return value
      },
      color: COLORS.white,
      font: {
        weight: "bold",
      },
      align: "center",
      textAlign: "center",
    },
  }
}

export const dataLabelsPluginComparative = (unit) => {
  return {
    datalabels: {
      display: function (context) {
        return context.dataset.data[context.dataIndex] !== 0
      },

      formatter: function (value, context) {
        const labelSource = Array.isArray(context.dataset.label)
          ? context.dataset.label[context.dataIndex] ?? context.dataset.label[0]
          : context.dataset.label
        const truncatedLabel = truncateLabel(labelSource, context)
        return `${truncatedLabel}\n ${context.dataset.value[context.dataIndex]} ${unit}`
      },
      textAlign: "center",
      color: COLORS.white,
      font: {
        weight: "bold",
      },
    },
  }
}
